<template>
  <div>
    <Debounce :time='300' :isDebounce="1">
      <el-button type="primary" @click.native="exportWord()" size="medium">查询</el-button>
    </Debounce>
    <div id="exportBox">
      这里是报价单模板

      <el-table :data="tableData" style="width: 700px;margin:0 auto">
        <el-table-column prop="cpasturename_price" label="公司" width="180">
        </el-table-column>
        <el-table-column prop="cinvname_price" label="物料描述" width="180">
        </el-table-column>
        <el-table-column prop="cmainunit_price" label="单位">
        </el-table-column>
        <el-table-column prop="ipricenum" label="询价数量">
        </el-table-column>
        <el-table-column label="含税报价">
        </el-table-column>
        <el-table-column label="备注">
        </el-table-column>
      </el-table>
    </div>

    <!-- <div class="reportTag" :id="chartsId"></div> -->
  </div>
</template>

<script>
import docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";

export default {
  props: {
    tableData: { type: Array },
    informdata: { type: Object },
  },
  name: "exportDocTemplate",
  data() {
    return {
      ccustomername: "",
      dxjstart: "",
      chtstart: "",
    };
  },
  created() {
    console.log(this.tableData, "4646749679798749796");
    this.dxjstart = this.informdata.dxjstart;
    this.ccustomername = JSON.parse(
      localStorage.getItem("userdata")
    ).ccustomername;
    this.getNowFormatDate();
    // console.log(this.dxjstart);
  },
  methods: {
    // 获取当前时间
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        date.getHours() +
        date.getMinutes() +
        date.getSeconds();
      this.chtstart = currentdate;
    },
    // 点击导出word
    exportWord: function () {
      let that = this;
      // 读取并获得模板文件的二进制内容
      JSZipUtils.getBinaryContent(
        "../../model.docx",
        function (error, content) {
          // model.docx是模板。我们在导出的时候，会根据此模板来导出对应的数据
          // 抛出异常
          if (error) {
            throw error;
          }

          // 创建一个PizZip实例，内容为模板的内容
          let zip = new PizZip(content);
          // 创建并加载docxtemplater实例对象
          let doc = new docxtemplater().loadZip(zip);
          // 设置模板变量的值
          doc.setData({
            table: that.tableData,
            ccustomername: that.ccustomername,
            dxjstart: that.dxjstart,
          });

          try {
            // 用模板变量的值替换所有模板变量
            doc.render();
          } catch (error) {
            // 抛出异常
            let e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties,
            };
            console.log(JSON.stringify({ error: e }));
            throw error;
          }

          // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
          let out = doc.getZip().generate({
            type: "blob",
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          // 将目标文件对象保存为目标类型的文件，并命名
          saveAs(out, that.chtstart + ".docx");
        }
      );
    },
  },
};
</script>

